import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import TheHeader from './components/layout/Header.vue';
import TheFooter from './components/layout/Footer.vue';
import WhatsAppButton from './components/layout/WhatsAppButton.vue'; // Verifique este import



export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.$route.meta.hideLayout)
      ? (_openBlock(), _createBlock(TheHeader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    (!_ctx.$route.meta.hideLayout)
      ? (_openBlock(), _createBlock(TheFooter, { key: 1 }))
      : _createCommentVNode("", true),
    (!_ctx.$route.meta.hideLayout)
      ? (_openBlock(), _createBlock(WhatsAppButton, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})